import { Link, useNavigate, useLocation } from "react-router-dom";
import { scrollToId, waLink, WA_DISPLAY, EMAIL } from "../data/content";
import { PRODUCTS } from "../data/products";
import { useLang, useT } from "../i18n";

const NAV = [
  { key: "home", hash: "#home" },
  { key: "about", hash: "#about" },
  { key: "products", hash: "#products" },
  { key: "partners", hash: "#partners" },
  { key: "quality", hash: "#quality" },
  { key: "markets", hash: "#markets" },
  { key: "contact", hash: "#contact" },
];

const Footer = () => {
  const { lang } = useLang();
  const t = useT();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const go = (hash) => {
    if (pathname !== "/") navigate(`/${hash}`);
    else scrollToId(hash);
  };

  return (
    <footer data-testid="footer" className="border-t border-gold/10 bg-[#0B132B]">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-12 px-4 py-16 sm:px-6 md:grid-cols-2 lg:grid-cols-4 lg:px-8">
        <div>
          <span className="inline-flex h-12 items-center rounded-sm bg-white px-3 py-1.5">
            <img src="/assets/logo.jpeg" alt="CRESSCO DAYA UTAMA logo" className="h-9 w-auto object-contain" />
          </span>
          <p className="mt-6 max-w-xs text-sm leading-relaxed text-slate-400">{t.footer.tagline}</p>
        </div>
        <div>
          <p className="mb-5 font-mono text-[10px] uppercase tracking-[0.3em] text-gold">{t.footer.navTitle}</p>
          <ul className="flex flex-col gap-3">
            {NAV.map((l) => (
              <li key={l.key}>
                <button
                  data-testid={`footer-nav-${l.key}`}
                  onClick={() => go(l.hash)}
                  className="text-sm text-slate-400 transition-colors duration-300 hover:text-gold"
                >
                  {t.nav[l.key]}
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="mb-5 font-mono text-[10px] uppercase tracking-[0.3em] text-gold">{t.footer.productsTitle}</p>
          <ul className="flex flex-col gap-3">
            {PRODUCTS.map((p) => (
              <li key={p.slug}>
                <Link
                  data-testid={`footer-product-${p.slug}`}
                  to={`/products/${p.slug}`}
                  className="text-sm text-slate-400 transition-colors duration-300 hover:text-gold"
                >
                  {p.name[lang]}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="mb-5 font-mono text-[10px] uppercase tracking-[0.3em] text-gold">{t.footer.contactTitle}</p>
          <ul className="flex flex-col gap-3 text-sm text-slate-400">
            <li>
              <a href={`mailto:${EMAIL}`} className="transition-colors duration-300 hover:text-gold">{EMAIL}</a>
            </li>
            <li>
              <a href={waLink(t.wa.generic)} target="_blank" rel="noopener noreferrer" className="transition-colors duration-300 hover:text-gold">
                {WA_DISPLAY}
              </a>
            </li>
            <li className="text-slate-500">cressco.co.id</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800/60">
        <div className="mx-auto flex max-w-[1400px] flex-col items-center justify-between gap-3 px-4 py-6 sm:px-6 md:flex-row lg:px-8">
          <p className="font-mono text-[10px] tracking-[0.15em] text-slate-600">{t.footer.rights}</p>
          <div className="flex items-center gap-5 font-mono text-[10px] tracking-[0.15em] text-slate-600">
            <span>{t.footer.privacy}</span>
            <span>{t.footer.terms}</span>
          </div>
          <p className="font-display text-xs italic text-gold/80">{t.footer.motto}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
